import PropTypes from 'prop-types';

export const ELEMENTS__ADD_UPLOAD = 'ELEMENTS__ADD_UPLOAD';
export const ELEMENTS__CREATE = 'ELEMENTS__CREATE';
export const ELEMENTS__DELETE = 'ELEMENTS__DELETE';
export const ELEMENTS__FETCH = 'ELEMENTS__FETCH';
export const ELEMENTS__PATCH = 'ELEMENTS__PATCH';
export const ELEMENTS__REPLACE = 'ELEMENTS__REPLACE';
export const ELEMENTS__REVOKE_UPLOAD = 'ELEMENTS__REVOKE_UPLOAD';
export const ELEMENTS__SEND_UPLOAD = 'ELEMENTS__SEND_UPLOAD';
export const ELEMENTS__UPDATE = 'ELEMENTS__UPDATE';

export const ELEMENT_TYPE__CANVAS = 'CanvasElement';
export const ELEMENT_TYPE__DESCRIPTION = 'DescriptionElement';
export const ELEMENT_TYPE__DISPLAY_REWARD = 'DisplayRewardElement';
export const ELEMENT_TYPE__HEADER = 'HeaderElement';
export const ELEMENT_TYPE__HYPERLINK = 'HyperlinkElement';
export const ELEMENT_TYPE__IMAGE = 'ImageElement';
export const ELEMENT_TYPE__TEXT = 'TextElement';

export const ELEMENT__STATIC_TYPES = [
  ELEMENT_TYPE__CANVAS,
  ELEMENT_TYPE__DESCRIPTION,
  ELEMENT_TYPE__DISPLAY_REWARD,
  ELEMENT_TYPE__HEADER,
  ELEMENT_TYPE__HYPERLINK,
  ELEMENT_TYPE__IMAGE,
  ELEMENT_TYPE__TEXT,
];

export const ELEMENT_TYPE__BOOLEAN_INPUT = 'BooleanInput';
export const ELEMENT_TYPE__CHECKBOX_INPUT = 'CheckboxInput';
export const ELEMENT_TYPE__DATE_INPUT = 'DateInput';
export const ELEMENT_TYPE__EMAIL_INPUT = 'EmailInput';
export const ELEMENT_TYPE__EMAIL_VERIFICATION_INPUT = 'EmailVerificationInput';
export const ELEMENT_TYPE__GIFTBIT_REWARD_INPUT = 'GiftbitRewardInput';
export const ELEMENT_TYPE__IMAGE_INPUT = 'ImageInput';
export const ELEMENT_TYPE__IMAGE_UPLOAD_INPUT = 'ImageUploadInput';
export const ELEMENT_TYPE__IMAGE_MULTI_SELECT_INPUT = 'ImageMultiSelectInput';
export const ELEMENT_TYPE__MEDIA_INPUT = 'MediaInput';
export const ELEMENT_TYPE__NUMBER_INPUT = 'NumberInput';
export const ELEMENT_TYPE__PHONE_NUMBER_INPUT = 'PhoneNumberInput';
export const ELEMENT_TYPE__RADIO_INPUT = 'RadioInput';
export const ELEMENT_TYPE__RANKING_IMAGE_INPUT = 'RankingImageInput';
export const ELEMENT_TYPE__RANKING_INPUT = 'RankingInput';
export const ELEMENT_TYPE__SLIDE_INPUT = 'SlideInput';
export const ELEMENT_TYPE__SOCIAL_INPUT = 'SocialInput';
export const ELEMENT_TYPE__TAROT_INPUT = 'TarotInput';
export const ELEMENT_TYPE__TEXT_INPUT = 'TextInput';
export const ELEMENT_TYPE__TEXTAREA = 'TextArea';
export const ELEMENT_TYPE__ZIP_INPUT = 'ZipInput';

export const ELEMENT__SHAPE_CSS = PropTypes.shape({
  alignContent: PropTypes.oneOf([
    'flex-start',
    'flex-end',
    'center',
    'space-between',
    'space-around',
    'stretch',
  ]),
  alignItems: PropTypes.oneOf(['flex-start', 'flex-end', 'center', 'baseline', 'stretch']),
  flexDirection: PropTypes.oneOf(['row', 'row-reverse', 'column', 'column-reverse']),
  flexWrap: PropTypes.oneOf(['nowrap', 'wrap', 'wrap-reverse']),
  justifyContent: PropTypes.oneOf([
    'flex-start',
    'flex-end',
    'center',
    'space-between',
    'space-around',
  ]),
});

export const ELEMENT__SHAPE = PropTypes.shape({
  createdAt: PropTypes.number,
  css: ELEMENT__SHAPE_CSS,
  id: PropTypes.string,
  name: PropTypes.string,
  pageId: PropTypes.string,
  parentId: PropTypes.string,
  type: PropTypes.string,
  version: PropTypes.number,
  visible: PropTypes.bool,
});

export const ELEMENT__SHAPE_ARRAY = PropTypes.arrayOf(ELEMENT__SHAPE);
